import React from "react";
import PropTypes from "prop-types";
import styles from "./EmptyState.module.css";

/**
 * Estado vazio compartilhado (F2.7).
 *
 * Um único componente para todos os "vazios" da epic CRM/Inbox — filas do Centro
 * de Mensagens, tela de Setores, notas internas — para que o tom (ícone amigável
 * + título opcional + descrição em token neutro) e o espaçamento fiquem
 * idênticos em toda a área, sem cada tela reinventar o seu.
 *
 * Variações:
 *  - `size="md"` (padrão): bloco centralizado com ícone grande (áreas de
 *    conteúdo — filas, Setores).
 *  - `size="sm"`: compacto, para painéis estreitos (notas internas).
 *  - `fill`: ocupa a altura disponível e centraliza verticalmente (quando o pai
 *    é uma coluna flex, ex.: a lista de conversas).
 *  - `action`: nó opcional para uma CTA (ex.: "Criar setor", "Tentar novamente").
 */
export default function EmptyState({
  icon,
  title,
  description,
  action,
  size = "md",
  fill = false,
  role,
  className = "",
}) {
  return (
    <div
      className={[styles.root, styles[size], fill ? styles.fill : "", className]
        .filter(Boolean)
        .join(" ")}
      role={role}
    >
      {icon != null && (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      )}
      {title && <p className={styles.title}>{title}</p>}
      {description && <p className={styles.description}>{description}</p>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}

EmptyState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.node,
  description: PropTypes.node,
  action: PropTypes.node,
  size: PropTypes.oneOf(["sm", "md"]),
  fill: PropTypes.bool,
  role: PropTypes.string,
  className: PropTypes.string,
};
